import { _axios } from '@/plugins/axios';

const evidenceResource = '/api/v1/evidence';

export default {
  all: () => _axios.get(`${evidenceResource}/all`),
  create: formData => _axios.post(`${evidenceResource}/create`, formData),
  update: formData => _axios.put(`${evidenceResource}/update`, formData),
  delete: id => _axios.delete(`${evidenceResource}/delete/${id}`),
  approveEvidence: id => _axios.put(`${evidenceResource}/approve/${id}`),
  download: evidence =>
    _axios.post(`${evidenceResource}/download`, evidence, { responseType: 'blob' }),
  rejectEvidence: reviewItem => _axios.put(`${evidenceResource}/reject`, reviewItem),
  reviewEvidence: reviewItem => _axios.put(`${evidenceResource}/review`, reviewItem),
  largelyCompliantEvidence: reviewItem =>
    _axios.put(`${evidenceResource}/largely-compliant`, reviewItem),
  checkDuplicateName: title => _axios.get(`${evidenceResource}/check-duplicate-name/${title}`),
  testEndpoint: id => _axios.get(`${evidenceResource}/test-endpoint/${id}`, { timeout: 60000 }),
};
